import Image from 'next/image';
import React from 'react';
import { IStationData, StationsListType } from '../../../Orchestrator/Types/Index';
import { useIntl } from 'react-intl';
import { getAmenitiesIconByName } from '../../../Lib/Utils/validationUtil';

interface NetworkMapStationCardProps {
  stationData: IStationData;
  onMoreDetails: () => void;
  stopsData?: StationsListType;
}

const NetworkMapStationCard: React.FC<NetworkMapStationCardProps> = ({ stationData, onMoreDetails, stopsData }) => {
  const intl = useIntl();

  // Find the stop that matches the station code
  const stop = stopsData?.find(s => s.id === stationData.code);

  // Helper to get localization key
  const getLocalizationKey = (locale: string) => {
    switch (locale) {
      case 'fr': return 'CULTURE.FR_FR';
      case 'ar': return 'CULTURE.AR_AE';
      case 'en':
      default: return 'CULTURE.EN_GB';
    }
  };

  return (
    <div className="col">
      <div className="network-content">
        <h2 className='network-heading'><span><Image
          src="/assets/booking/red-train.svg"
          width={28}
          height={28}
          alt="back"
        /></span> {stationData?.name}</h2>

        {/* <div className="station-services">
          <ul>
            <li><span>
              <Image
                src="/assets/network_icons/wifi.svg"
                width={24}
                height={24}
                alt="back"
              /></span>Wi-Fi</li>
            <li><span>
              <Image
                src="/assets/network_icons/sofa.svg"
                width={24}
                height={24}
                alt="back"
              /></span>VIP Lounge</li>
            <li><span>
              <Image
                src="/assets/network_icons/user-star.svg"
                width={24}
                height={24}
                alt="back"
              /></span>Fast Track</li>
            <li><span>
              <Image
                src="/assets/network_icons/tv.svg"
                width={24}
                height={24}
                alt="back"
              /></span>TVM</li>
            <li><span>
              <Image
                src="/assets/network_icons/coupon.svg"
                width={24}
                height={24}
                alt="back"
              /></span>Ticket Office</li>
            <li><span>
              <Image
                src="/assets/network_icons/shopping-basket.svg"
                width={24}
                height={24}
                alt="back"
              /></span>Shops</li>
          </ul>
        </div> */}

        <div className="station-services">
          <ul>
            {stop?.attributes?.map(attr => {
              const locKey = getLocalizationKey(intl.locale);
              const label = attr.localizations?.[locKey] || attr.name;
              // Map code or name to an icon file
              const iconSrc = getAmenitiesIconByName(attr.code);
              return (
                <li key={attr.code}>
                  {iconSrc && <span>
                    <Image
                      src={iconSrc}
                      width={24}
                      height={24}
                      alt={label}
                      onError={(e: any) => { e.currentTarget.src = ''; }}
                    />
                  </span>}
                  {label}
                </li>
              );
            })}
          </ul>
        </div>
        <button className='btn cursor-pointer' onClick={onMoreDetails}>{intl.formatMessage({ id: "moreDetails" })} <span>
          <Image
            src="/assets/network_icons/chevron_right.svg"
            width={8}
            height={12}
            alt="arrow"
          /></span></button>
      </div>
      <div className="network-image">
        <Image
          // src="/images/dubai_city.svg"
          src={stationData.image?.[0]?.formats?.medium?.url ||
            stationData.image?.[0]?.url || "/images/dubai_city.svg"}
          alt=""
          width={628}
          height={660}
        />
      </div>
    </div>
  );
};

export default NetworkMapStationCard; 